module.exports = __webpack_public_path__ + "static/media/DecCreditCard@2x.guaranteed-rate.08e69b56.png";